import React from "react";
import { Link } from "react-router-dom";
import ModuleHeroMockup from "./ModuleHeroMockup";

const HAS_MOCKUP = { partners: true, profile: true, skills: true, pilot: true, cv: true };

const ModuleHero = ({ moduleKey, label, hero, screenshot }) => {
  const useMockup = HAS_MOCKUP[moduleKey];
  return (
    <header className="mk-hero" id="top" data-testid="module-section-hero">
      <div className="mk-wrap mk-hero-grid">
        <div className="mk-hero-copy mk-reveal">
          <span className="mk-eyebrow">
            <span className="mk-pulse" aria-hidden="true" />
            {hero.eyebrow || label}
          </span>
          <h1 className="mk-hero-title" data-testid="module-hero-title" style={{ fontSize: "clamp(40px, 5vw, 76px)" }}>
            {hero.title}
          </h1>
          <p className="mk-lead">{hero.lead}</p>
          <div className="mk-hero-actions">
            <Link
              to={`/contact?module=${encodeURIComponent(moduleKey)}`}
              className="mk-btn mk-btn-primary"
              data-testid="module-hero-cta"
            >
              Demander une démo
            </Link>
            <Link to="/#tarifs" className="mk-btn mk-btn-ghost">
              Voir les tarifs
            </Link>
          </div>
        </div>

        <div className="mk-hero-lab mk-reveal" aria-label={`Aperçu produit ${label}`}>
          <div className="mk-hero-device">
            <div className="mk-browser">
              <div className="mk-lights"><span /><span /><span /></div>
              <span>{`www.asap-hub.ai/${moduleKey}`}</span>
            </div>
            {useMockup ? (
              <ModuleHeroMockup moduleKey={moduleKey} />
            ) : screenshot ? (
              <img
                src={screenshot.src}
                alt={screenshot.alt}
                loading="lazy"
                style={{ display: "block", width: "100%", height: "auto" }}
              />
            ) : (
              <div style={{ padding: "48px", color: "#aab8cb" }}>{label}</div>
            )}
          </div>
        </div>
      </div>
    </header>
  );
};

export default ModuleHero;
